import React, { useState } from 'react';

import { DeviceDetailsProperties } from '../../../../interface/device-management.interface';

import ConnectorStatus from './ConnectorStatus';
import DeviceContentTabs from './DeviceContentTabs';
import DeviceMap from './DeviceMap';

/**
 * Component to display the top container of the device details page
 * @returns
 */
function DeviceDetailsTopContainer() {
  const [selectedDeviceGeneral, setSelectedDeviceGeneral] = useState<DeviceDetailsProperties>({
    connectors: [],
  });

  return (
    <div className="device-details-top-container-wrap">
      {/* <div className="device-tabs-content"> */}
      <DeviceContentTabs
        selectedDeviceGeneral={selectedDeviceGeneral}
        setSelectedDeviceGeneral={setSelectedDeviceGeneral}
      />
      {/* </div> */}
      {/* <div className="device-map"> */}
      <DeviceMap />
      {/* </div> */}
      {/* display non for hiding connecter status chart */}
      <div className="device-kwh-container" style={{ display: 'none' }}>
        <ConnectorStatus selectedDeviceGeneral={selectedDeviceGeneral} />
      </div>
    </div>
  );
}

export default DeviceDetailsTopContainer;
